import * as React from "react";
import { forwardRef } from "react";
const DeleteBinIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "data-category": "other",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.42857 1.5c-.68198 0-1.33604.27092-1.81827.75315-.48224.48224-.75316 1.13629-.75316 1.81828v.85714H.857143C.383756 4.92857 0 5.31233 0 5.78571c0 .47339.383756.85715.857143.85715H3.42857V21.2143c0 .682.27092 1.336.75316 1.8183.48223.4822 1.13628.7531 1.81827.7531h12c.682 0 1.336-.2709 1.8183-.7531.4822-.4823.7531-1.1363.7531-1.8183V6.64286h2.5715c.4733 0 .8571-.38376.8571-.85715 0-.47338-.3838-.85714-.8571-.85714h-6v-.85714c0-.68199-.271-1.33604-.7532-1.81828C15.9075 1.77092 15.2534 1.5 14.5714 1.5zm-.60609 1.96534c.16075-.16075.37876-.25105.60609-.25105h5.14283c.2274 0 .4454.0903.6061.25105.1608.16074.2511.37876.2511.60609v.85714H8.57143v-.85714c0-.22733.0903-.44535.25105-.60609M5.14286 21.2143V6.64286H18.8571V21.2143c0 .2273-.0903.4453-.251.6061-.1608.1607-.3788.251-.6061.251H6c-.22733 0-.44535-.0903-.60609-.251-.16075-.1608-.25105-.3788-.25105-.6061m3.42857-10.2857c0-.4734.38375-.8572.85714-.8572s.85713.3838.85713.8572v6.8571c0 .4734-.38374.8572-.85713.8572s-.85714-.3838-.85714-.8572zm6.85717 0c0-.4734-.3838-.8572-.8572-.8572s-.8571.3838-.8571.8572v6.8571c0 .4734.3837.8572.8571.8572s.8572-.3838.8572-.8572z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(DeleteBinIcon);
ForwardRef.category = "other";
export { ForwardRef as DeleteBinIcon };